<div class="container" [ngClass]="{ mobile: isMobile$ | async }">
  <h2 class="mat-headline-3 align-center">{{ 'WM_TECH.CONTACT_US.TITLE' | translate }}</h2>

  <mat-card class="auth-card">
    <mat-card-content>
      <form #formDirective="ngForm" [formGroup]="contactForm" (ngSubmit)="contact(formDirective)" class="sign-in-form">
        <mat-form-field appearance="outline" class="wm-input">
          <input formControlName="email" matInput [placeholder]="'WM_TECH_POOL.FORMS.EMAIL' | translate" type="email" required />
        </mat-form-field>

        <mat-form-field appearance="outline" class="wm-input">
          <textarea formControlName="message" matInput required [placeholder]="'WM_TECH_POOL.FORMS.MESSAGE' | translate" rows="10"></textarea>
        </mat-form-field>

        <button mat-raised-button color="tech-button-bg-primary" type="submit" class="submit-button" [disabled]="contactForm.invalid">
          {{ 'WM_TECH.CONTACT_US.SEND' | translate }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
